import { Map } from 'immutable';

import { PERSON_REGISTRY_FILES_REQUEST, PERSON_REGISTRY_FILES_FAILURE, PERSON_REGISTRY_FILES_SUCCESS } from './action';

const initialState = Map({
  type: '',
  payload: Map({}),
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === PERSON_REGISTRY_FILES_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], Map({}));
  }

  if (type === PERSON_REGISTRY_FILES_FAILURE) {
    const { payload } = action;
    return state.updateIn(['type'], () => type).setIn(['payload'], Map(payload));
  }

  if (type === PERSON_REGISTRY_FILES_SUCCESS) {
    const { payload } = action;
    return state.updateIn(['type'], () => type).setIn(['payload'], Map(payload));
  }

  return state;
}

export default reducer;
